import { render, staticRenderFns } from "./FeaturesManagement.vue?vue&type=template&id=98015828&scoped=true&"
import script from "./FeaturesManagement.vue?vue&type=script&lang=js&"
export * from "./FeaturesManagement.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesManagement.vue?vue&type=style&index=0&id=98015828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98015828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98015828')) {
      api.createRecord('98015828', component.options)
    } else {
      api.reload('98015828', component.options)
    }
    module.hot.accept("./FeaturesManagement.vue?vue&type=template&id=98015828&scoped=true&", function () {
      api.rerender('98015828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/FeaturesManagement.vue"
export default component.exports